export default __webpack_public_path__ + "static/media/Abp_logo.e225eb39.png";